module.exports = __webpack_public_path__ + "static/media/head-left-side.91ddcab6.png";